import {Dialog} from '@base-ui/react/dialog';
import {CloseIcon} from '@uwm/ui';

import {getContent} from '@/services/content/content';
import type {TipData} from '@/types/experienceScore';

import TipItem from './TipItem';

const getRootElement = () => document.getElementById('root');

interface TipNotificationExpandedLayerProps {
    id: string;
    open: boolean;
    onClose: () => void;
    tips: TipData[];
}

const TipNotificationExpandedLayer = ({id, open, onClose, tips}: TipNotificationExpandedLayerProps) => {
    const {tipsTitle} = getContent().experienceScoreContent ?? {};

    return (
        <Dialog.Root open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            {/* #root carries .dark, so a portal to document.body would drop every dark: variant. */}
            <Dialog.Portal container={getRootElement()}>
                <Dialog.Backdrop className='fixed inset-0 z-100 bg-hard-white/70 backdrop-blur-sm transition-opacity duration-500 data-ending-style:opacity-0 data-starting-style:opacity-0 motion-reduce:transition-none dark:bg-orion-2/70' />
                {/* Tailwind 4 translate-* sets `translate`, not `transform`. */}
                <Dialog.Popup
                    id={id}
                    aria-label={tipsTitle}
                    className='fixed inset-x-0 bottom-0 z-101 flex max-h-dvh w-full flex-col overflow-hidden rounded-t-3xl px-4 pt-inset-4 transition-[opacity,translate] duration-500 data-ending-style:translate-y-10 data-starting-style:translate-y-10 data-ending-style:opacity-0 data-starting-style:opacity-0 motion-reduce:transition-none'
                >
                    <div className='flex min-h-15 shrink-0 justify-end pb-4'>
                        <Dialog.Close
                            aria-label={tipsTitle}
                            className='flex size-11 cursor-pointer items-center justify-center rounded-full bg-light-silver dark:bg-orion-card'
                        >
                            <CloseIcon />
                        </Dialog.Close>
                    </div>
                    <div className='flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto pt-4 pb-8'>
                        {tips.map((tip, i) => (
                            <TipItem key={tip.code ?? tip.title ?? `tip-${i}`} tip={tip} onBeforeAction={onClose} />
                        ))}
                    </div>
                </Dialog.Popup>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export default TipNotificationExpandedLayer;
